(ns motorsaif.web.pwa
  (:require
   ;; [cljs.pprint]
   [promesa.core :as p]
   ["react-transition-group" :refer [CSSTransition TransitionGroup SwitchTransition]]
   [motorsaif.time :as time]
   [motorsaif.web.storage :as storage]
   [motorsaif.log :as log]
   [shadow.cljs.modern :refer (js-await)]
   [re-frame.core :as rf :refer [subscribe dispatch]]
   [reagent.core :as r]
   [motorsaif.utils :as utils]))

;; Service worker flow.
;; We register it
;; (js/navigator.serviceWorker.register url)
;; Get the registrations
;; We only register one, so the scope doesn't matter
;; (js/navigator.serviceWorker.getRegistrations)
;; This returns an array, grab first one.


(defonce *push-sub (r/atom nil))
(defonce *worker-nav-reg (atom nil))

;; We store the registration here
(defonce *sw-reg (atom nil))

;; This is the main thing that allows us to even know if this is possible.
(def ^:private ?push-manager (.-PushManager js/window))
(def can-push? (some? ?push-manager))


(defn sub-backend-id
  "Returns true if the current client is subscribed in backend"
  []
  (let [sub-endpoint (some-> @*push-sub .-endpoint)]
    (:db/id (first (filter
             #(= (get-in % [:client/sub "endpoint"]) sub-endpoint)
             @(rf/subscribe [:push-clients]))))))

(defn is-backend-subbed
  "Returns true if the current client is subscribed in backend"
  []
  (let [sub-endpoint (some-> @*push-sub .-endpoint)]
    (some
     #(= (get-in % [:client/sub "endpoint"]) sub-endpoint)
     @(rf/subscribe [:push-clients]))))

;; The possible push outcomes that will give guidance on how to proceed
;; to enable webpush
(defn pushable-state []
  (cond
    (is-backend-subbed)
    :fully-subbed

    can-push?
    :can-push

    utils/is-pwa?
    :pwa-without-push

    ;; user needs to add app to homescreen
    utils/is-ios?
    :ios-install-app))

(defn is-subbed?
  "Returns true if push notifications are enabled or can be enabled"
  []
  (some? (#{:fully-subbed} (pushable-state))))

(defn notifiable?
  "Returns true if push notifications are enabled or can be enabled"
  []
  (some? (#{:can-push :fully-subbed} (pushable-state))))

(defn can-sub? []
  (and
   (notifiable?)
   (not (is-subbed?))))

(defn ensure-sw
  "Installs service worker if it does not exist, sets `*sw-reg` atom with the
  service worker registration"
  []
  (let [url "/static/js/service-worker.js"]
    (p/let [regs (js/navigator.serviceWorker.getRegistrations)
            existing-reg (first regs)
            new-reg (when-not existing-reg
                      (js/navigator.serviceWorker.register url))
            reg (or existing-reg new-reg)
            sub (some-> reg .-pushManager .getSubscription)]
      (log/info [:SW reg])
      (reset! *sw-reg (or existing-reg reg))
      (reset! *push-sub sub)
      reg)))

(comment
  (ensure-sw)
  (p/let [?reg (js/navigator.serviceWorker.getRegistrations)]
    (def zef ?reg))
  ;; (map #(aget % "scope") (array-seq zef))
  ;; (map js-keys (array-seq zef))
  )

(defn make-push-sub-from-browser-api!
  "Installs service worker if none exists."
  []
  (let [js-key "BIZg5UmDYvgiTuj7C6L3MflSJQ2U2hH4vUdfRwPspZ3WrOIncAzhHigSTLvlEXBLFYSmAH_pdJyrhIfwbAG3GOI"
        sub-options #js {:userVisibleOnly true
                         :applicationServerKey (js/urlBase64ToUint8Array js-key)}]
    (p/let [ret (some-> @*sw-reg .-pushManager ^js (.subscribe sub-options))]
      (reset! *push-sub ret)
      ret)))

(defn update-current-notification-state
  "Doesn't return anything at least in ff"
  []
  (p/let [ret (js/navigator.permissions.query #js {:name "notifications"})]
    (dispatch [:assoc-data [:pwa :notification-state]
               {:notification-state (.-state ret)
                :sub @*push-sub}])
    (println (name (.-state ret)))))

(comment
  (:sub (:pwa @re-frame.db/app-db)))

;; (defn register-webpush! []
;;   (p/let [sub (or @*push-sub (create-sub!))]
;;     (println [:sub (js/JSON.stringify (.-endpoint sub))])
;;     (dispatch [:register-webpush sub])))

(comment
  (ensure-sw)
  (ask-enable-notifications))

(defn register-sub! []
  (p/let [push-sub (or @*push-sub (make-push-sub-from-browser-api!))
          sub (js/JSON.stringify push-sub)]
    (when push-sub
      (dispatch [:register-push-sub :web {:sub sub}]))))

(defn ask-enable-notifications
  "Ask to enable notifications, then subscribe to web push."
  []
  (p/let [ret (.requestPermission js/Notification)]
    (log/info [:permission ret])
    (if (= ret "denied")
      (dispatch [:toast {:type "error"
                         :auto-close false
                         :title "Notifications Disabled"
                         :message "Please enable notifications manually in your settings."}])
      (register-sub!))))

(comment
  (ask-enable-notifications)
  (dispatch [:toast {:type "error"
                     :auto-close false
                     :draggable false
                     :close-on-click false
                     :title "title"
                     :buttons [{:title "Yes"
                                :click (fn [close]
                                         (log/info "Yes")
                                         (close))}
                               {:title "no"
                                :click (fn [] (log/info "no"))}]
                     :message "Pleaese enable notifications manually in your settings."}])

  (dispatch [:toast {:type "error"
                     :auto-close false
                     :close-on-click false
                     :buttons [{:title "Yes"
                                :afn (fn [] (log/info "Yes"))}
                               {:title "no"
                                :afn (fn [] (log/info "no"))}]
                     :message
                     [:div.toast-notification
                      [:div.title "title"]
                      [:div.msg
                       "Pleaese enable notifications manually in your settings."]]}])

  (.then (ask-enable-notifications)))

(defn update-sw []
  (.update @*worker-nav-reg))

(comment
  (.active.postMessage @*sw-reg true)
  (js/console.log @*sw-reg)
  (js-keys (.-pushManager.getSubscription @*sw-reg))
  (.pushManager.getSubscription @*sw-reg)
  (ensure-sw))


(defonce *install-event (r/atom nil))

;; Listen for the beforeinstallprompt event and store it
(.addEventListener js/window "beforeinstallprompt"
                   (fn [e]
                     (.preventDefault e) ;; Optional: prevent auto-prompt
                     (reset! *install-event e)))

(def installable?
  (and
   (or utils/is-android? utils/is-ios?)
   (not utils/is-pwa?)))

(defn install-notification []
  (let [id "install-notification"
        dismiss-fn #(do
                      (dispatch [:set-ui-state :install-pwa false]))

        *video-loaded? (r/atom false)]

    (fn []
      [:> CSSTransition
       {:timeout 300
        :unmountOnExit true
        :in @(subscribe [:ui-state :install-pwa])
        :classNames "install"}
       [:div
        {:id id}
        [:div.wrap
         [:div.title
          [:i.fas.fa-download]
          [:span "MotorSaif App"]]
         [:p.desc
          "Never miss a message.
Get notifications by adding this app to your home screen."]

         (if utils/is-ios?
           [:div.body.ios
            [:span
             "To install on iPhone"]
            [:div.grid
             [:ol
              [:li "Tap the share icon in Safari"]
              [:li "Select " [:strong "Add to Home Screen"]]
              [:li "Tap " [:strong "Add"] " to confirm"]]
             [:video#ios-install-vid {:autoPlay true
                                      :class (when-not @*video-loaded? "hidden")
                                      :loop true
                                      :onLoadedData #(reset! *video-loaded? true)
                                      :style {:background "transparent"}
                                      :playsInline true
                                      :muted true
                                      :src "/static/vid/iosaddhomescreen.mp4"}]]]

           (when-not @*install-event
             [:div.body.android
              [:span
               "To install on Android"]
              [:ol
               [:li "Tap the menu : in Chrome"]
               [:li "Select "
                [:strong "Install app"]]
               [:li "Tap " [:strong "Install"] " to confirm"]]]))

         [:div.btns
          [:button.btn.outline.reset-button.not-now
           {:on-click dismiss-fn}
           "Not Now"]
          (when @*install-event
            [:button.btn.primary.reset-button
             {:on-click #(when-let [evt @*install-event]
                           (.prompt evt)
                           (reset! @*install-event nil))}
             "Install"
             [:i.fas.fa-download]])]]]])))
